import type { FC } from "react";
import type { ProductHistoricalInsights } from "../historical-insights.types";
import { formatSnakeCase } from "../insights-utils";

interface Props {
  declined: ProductHistoricalInsights["declined"];
}

export const InsightsDeclinedSection: FC<Props> = ({ declined }) => {
  if (declined.totalCount === 0) {
    return null;
  }

  const categoryEntries = Object.entries(declined.byCategory);

  return (
    <div className="space-y-3">
      <h3 className="text-sm font-semibold">Declined ({declined.totalCount})</h3>

      {declined.topDeclinedClasses.length > 0 && (
        <div>
          <h4 className="text-xs font-medium text-muted-foreground mb-1">Top Declined Classes</h4>
          <div className="space-y-1">
            {declined.topDeclinedClasses.map((item) => (
              <div key={item.class} className="flex justify-between text-xs">
                <span>{item.class}</span>
                <span className="text-muted-foreground">{item.count}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      {declined.topDeclinedStates.length > 0 && (
        <div>
          <h4 className="text-xs font-medium text-muted-foreground mb-1">Top Declined States</h4>
          <div className="space-y-1">
            {declined.topDeclinedStates.map((item) => (
              <div key={item.state} className="flex justify-between text-xs">
                <span>{item.state}</span>
                <span className="text-muted-foreground">{item.count}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      {categoryEntries.length > 0 && (
        <div>
          <h4 className="text-xs font-medium text-muted-foreground mb-1">By Category</h4>
          <div className="space-y-1">
            {categoryEntries.map(([category, count]) => (
              <div key={category} className="flex justify-between text-xs">
                <span>{formatSnakeCase(category)}</span>
                <span className="text-muted-foreground">{count}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
